export default "__VITE_ASSET__DQOpWL0G__"